import axios, { InternalAxiosRequestConfig } from "axios";

export const baseURL = import.meta.env.VITE_API_BASE_URL;
const http = axios.create({
  baseURL,
});

let abortController: AbortController | null = null;

http.interceptors.request.use(function (config) {
  const token = localStorage.getItem("access_token");

//   // Cancel previous request if it exists
//   if (abortController) {
//     abortController.abort();
//   }

  // Create a new AbortController for the current request
  abortController = new AbortController();
  config.signal = abortController.signal; // Attach the signal to the request

  return {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` },
  } as InternalAxiosRequestConfig;
});

http.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.name === 'AbortError') {
      console.log('Request was aborted');
    } else if (error.response?.status === 401) {
      if (localStorage.getItem("access_token")) {
        localStorage.removeItem("access_token");
        // window.location.replace("/auth/login");
      }
    }
    return Promise.reject(error);
  }
);

// Function to cancel ongoing requests
export const cancelRequests = () => {
  if (abortController) {
    abortController.abort();
    abortController = null; // Reset the controller
  }
};

export default http;